import * as React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import * as ExploreApiServices from '../../../services/api/requests/Explore'
import * as ProfileApiServices from '../../../services/api/requests/Profile'
import * as EConcierge from '../../../services/api/requests/EConcierge'
import * as EFoodChoices from '../../../services/api/requests/EFoodChoices'

import Icon from '../../ui/Icon/Icon'
import TextInput from '../../ui/TextInput/TextInput'

import searchResultTypes from '../../../services/data/searchResultTypes'
import getDeviceLocation from '../../../services/location/getDeviceLocation'
import {
  setGACustomEvent,
  setGAEvent,
} from '../../../services/analytics/google-analytics'
import DialogModal from '../../ui/DialogModal/DialogModal'
import {
  StyledReactModal,
  SearchContentContainer,
  Header,
  Title,
  CloseIcon,
  SearchFieldsContainer,
  OffsetInput,
  InputHidden,
  PositionError,
  PositionErrorText,
  PositionErrorIcon,
  PositionErrorWrapper,
  SearchResults,
  Label,
  LabelText,
  ClearSearch,
  RecentSearchWrapper,
  RecentSearchItem,
  ResultEvents,
  StyledSlider,
  ResultEvent,
  ResultEventContainer,
  ResultEventText,
  EventImage,
  SearchEventTitle,
  EventSubtitle,
  Result,
  ResultText,
  SearchTitle,
  Subtitle,
  NoResults,
  LoaderContainer,
  StyledLoader,
  StyledSearchMall,
} from './SearchModal.style'

const overlay = {
  zIndex: 999,
  background: 'rgba(0, 0, 0, 0.8)',
}

const content = {}

class SearchModal extends React.Component {
  debouncedSearch = _.debounce(() => {
    const { keyword, mallId, selectedMall } = this.state
    const { accessToken, contentType, isEfoodChoices, isExplore } = this.props

    this.setState({
      isUserSearching: true,
    })

    if (!mallId && !keyword && !isEfoodChoices) {
      this.getRecentSearches(accessToken)

      this.setState({
        isUserSearching: false,
        results_articles: [],
        results_places: [],
        dragging: false,
      })

      return
    }

    this.setLoading(true)

    if (!isEfoodChoices) {
      if (isExplore) {
        ExploreApiServices.exploreSearch(
          mallId,
          keyword.length >= 3 ? keyword : '',
          contentType,
        )
          .then(response => {
            this.setLoading(false)

            const responseData = response.data

            let articles = []
            let places = []

            responseData.forEach(result => {
              if (result.type === 2) {
                articles.push(result)
                places.push(result)
              }
            })

            this.setState({
              results_articles: articles,
              results_places: places,
            })

            setGACustomEvent('search', { mall_directory_search: keyword })

            if (responseData.length === 0) {
              setGAEvent('search', 'search_no_response', keyword)
            }
          })
          .catch(() => {})
      } else {
        ExploreApiServices.exploreSearch(mallId, keyword, contentType)
          .then(response => {
            this.setLoading(false)

            const responseData = response.data

            let articles = []
            let places = []

            for (var i = 0; i < responseData.length; i++) {
              if (
                responseData[i].type !== searchResultTypes.STORES &&
                responseData[i].type !== searchResultTypes.MERCHANTS &&
                responseData[i].type !== searchResultTypes.AMENITIES
              ) {
                articles.push(responseData[i])
              } else {
                places.push(responseData[i])
              }
            }

            this.setState({
              results_articles: articles,
              results_places: places,
            })

            setGAEvent('search', 'search_explore', keyword)

            if (responseData.length === 0) {
              setGAEvent('search', 'search_no_response', keyword)
            }
          })
          .catch(() => {})
      }
    } else {
      EFoodChoices.searchMallMerchants(
        {
          mallSlugName: selectedMall ? selectedMall.mallSlugName : '',
          brandName: keyword,
        },
        accessToken,
      )
        .then(response => {
          this.setLoading(false)

          const responseData = response.data

          let articles = []
          let places = []

          for (var i = 0; i < responseData.length; i++) {
            if (
              Number(responseData[i].type) === searchResultTypes.EVENTS &&
              Number(responseData[i].type) === searchResultTypes.PROMOS &&
              Number(responseData[i].type) ===
                searchResultTypes.ANNOUNCEMENTS &&
              Number(responseData[i].type) === searchResultTypes.ADS &&
              Number(responseData[i].type) === searchResultTypes.OTHERS
            ) {
              articles.push(responseData[i])
            } else {
              places.push({
                ...responseData[i],
                itemId: responseData[i].id,
                iconUrl: responseData[i].logoUrl,
                subtitle: responseData[i].description,
                title: responseData[i].name,
                type: 2,
              })
            }
          }

          this.setState({
            results_articles: articles,
            results_places: places,
          })

          setGAEvent('search', 'search_efood_choices', keyword)

          if (responseData.length === 0) {
            setGAEvent('search', 'search_no_response', keyword)
          }
        })
        .catch(() => {})
    }
  }, 250)

  constructor(props) {
    super(props)
    const { initialMall } = props

    this.state = {
      keyword: '',
      mallId: initialMall ? initialMall.id : '',
      results_articles: [],
      results_places: [],
      recentSearches: [],
      popularPlaces: [],
      isUserSearching: false,
      loading: false,
      showSearchMall: false,
      initialMall: initialMall || {},
      selectedMall: initialMall || {},
      favoriteMalls: [],
      favoriteLoadingStatus: null,
      position: null,
      positionLoading: null,
      loginPromptModalVisible: false,
      maxFavoriteModalVisible: false,
    }
  }

  componentDidMount() {
    const { accessToken } = this.props

    this.getPopularPlaces()

    if (accessToken) {
      this.getRecentSearches(accessToken)
    }

    this.setState({
      positionLoading: true,
    })

    getDeviceLocation().then(
      location => {
        this.setState({
          position: {
            latitude: location.coords.latitude,
            longitude: location.coords.longitude,
          },
          positionLoading: false,
        })
      },
      () => {
        this.setState({
          positionLoading: false,
        })
      },
    )
    this.search()
  }

  componentDidUpdate(prevProps, prevState) {
    const { accessToken, initialMall, malls, isEconcierge } = this.props

    if (accessToken !== prevProps.accessToken) {
      this.getRecentSearches(accessToken)
    }

    if (initialMall !== prevProps.initialMall || malls !== prevProps.malls) {
      this.updateSeletedMallState(initialMall)
    }

    if (
      isEconcierge &&
      prevState.selectedMall.slugName !== this.state.selectedMall.slugName
    )
      this.getPopularPlaces()
    // if (malls !== prevProps.malls) {
    //   const selectedMall =
    //     malls.find(mall => mall.slugName === selectedMallSlug) || {}

    //   this.updateSeletedMallState(selectedMall)
    // }
  }

  getFavoriteMalls = async () => {
    const { accessToken, setFavoriteMalls } = this.props
    this.setState({
      favoriteLoadingStatus: 0,
    })

    if (accessToken) {
      try {
        const favoriteResponse = await ProfileApiServices.getAllFavoriteMalls(
          accessToken,
        )

        setFavoriteMalls(favoriteResponse.data)

        this.setState({
          favoriteMalls: favoriteResponse.data,
          favoriteLoadingStatus: 1,
        })
      } catch (e) {
        this.setState({
          favoriteMalls: [],
          favoriteLoadingStatus: 4,
        })
      }
    }
  }

  handleBeforeChange = () => {
    this.setState({ dragging: true })
  }

  handleAfterChange = () => {
    this.setState({ dragging: false })
  }

  updateSeletedMallState = selectedMall => {
    this.setState({
      selectedMall: selectedMall || {},
      mallId: selectedMall ? selectedMall.id : '',
    })
  }

  getRecentSearches = accessToken => {
    ProfileApiServices.getUserRecentSearches(accessToken)
      .then(response => {
        this.setState({
          recentSearches: response.data,
        })
      })
      .catch(() => {})
  }

  //
  getPopularPlaces = async () => {
    const { isEconcierge } = this.props
    const { selectedMall } = this.state
    const { data } = await (isEconcierge
      ? EConcierge.getAllPopularPlaces(selectedMall && selectedMall.slugName)
      : ExploreApiServices.getAllMerchants())
    this.setState({
      popularPlaces: data.map(item => ({
        itemId: item.id,
        title: item.name,
        subtitle: item.description,
        type: 2.5,
      })),
    })
  }

  search = () => {
    this.debouncedSearch()
  }

  resultClick = (result, status = null) => {
    if (!(status === 'events' && this.state.dragging)) {
      const {
        accessToken,
        push,
        malls,
        onSelectMerchant,
        isEfoodChoices,
      } = this.props
      const { mallId, keyword } = this.state
      const { itemId, title } = result
      const {
        EVENTS,
        PROMOS,
        STORES,
        MERCHANTS,
        AMENITIES,
        ANNOUNCEMENTS,
        ADS,
        OTHERS,
      } = searchResultTypes

      const selectedMall = malls.filter(mall => mall.id === mallId)
      // REMOVED - postUserSearches function no longer exists
      // if ((mallId || keyword) && accessToken) {
      //   ProfileApiServices.postUserSearches(result, accessToken)
      //     .then(() => {})
      //     .catch(() => {})
      // }

      if (result.type === EVENTS || result.type === PROMOS) {
        push(`/main/${result.type ? 'promo' : 'event'}/${itemId}`)

        setGAEvent('search', 'view_search_results_explore', title)
      }

      if (result.type === STORES && !isEfoodChoices) {
        if (onSelectMerchant) {
          onSelectMerchant(itemId)
        } else {
          push(`/explore/${selectedMall.slugName || 'malls'}/store/${itemId}`)
        }
        this.modalClose()

        setGAEvent('search', 'view_search_results_explore', title)
      }

      if (isEfoodChoices) {
        if (onSelectMerchant) {
          onSelectMerchant(result)
        } else {
          push(`/explore/${selectedMall.slugName || 'malls'}/store/${itemId}`)
        }

        setGAEvent('search', 'view_search_results_efood', title)
      }

      if (result.type === MERCHANTS) {
        if (onSelectMerchant) {
          onSelectMerchant(itemId)
        } else {
          push(
            `/explore/${selectedMall.slugName || 'malls'}/merchant/${itemId}`,
          )
        }
        this.modalClose()

        setGAEvent('search', 'view_search_results_explore', title)
      }

      if (result.type === AMENITIES) {
        ExploreApiServices.getAmenity(itemId).then(response => {
          const { data } = response

          if (push) {
            push(`/wayfinding/${data.mall.slugName}/location/${itemId}`)
          }

          setGAEvent('search', 'selected_searched_amenity', data.name)
          setGAEvent('search', 'view_search_results_explore', data.name)
        })
      }

      if (result.type === ANNOUNCEMENTS) {
        push(`/main/announcements/${itemId}`)
        setGAEvent('search', 'view_search_results_explore', title)
      }

      if (result.type === ADS) {
        push(`/main/ads/${itemId}`)
        setGAEvent('search', 'view_search_results_explore', title)
      }

      if (result.type === OTHERS) {
        push(`/main/others/${itemId}`)
        setGAEvent('search', 'view_search_results_explore', title)
      }
    }
  }

  clearRecentSearches = () => {
    // const { accessToken } = this.props

    // REMOVED - deleteUserRecentSearches function no longer exists
    // if (accessToken) {
    //   ProfileApiServices.deleteUserRecentSearches(accessToken)
    //     .then(() => {
    //       this.setState({
    //         recentSearches: [],
    //       })
    //     })
    //     .catch(() => {})
    // }

    this.setState({
      recentSearches: [],
      results_articles: [],
      results_places: [],
    })
  }

  modalClose = () => {
    const { onClose } = this.props

    if (onClose) {
      onClose(false)
    }

    this.setState({
      results_articles: [],
      results_places: [],
      mallId: '',
      selectedMall: '',
    })
  }

  setLoading = state => {
    this.setState({
      loading: state,
    })
  }

  showSelectMall = async () => {
    this.setState(
      {
        showSearchMall: true,
        favoriteMalls: [],
        favoriteLoadingStatus: null,
      },
      () => {
        this.getFavoriteMalls()
      },
    )
  }

  handleKeywordChange = async event => {
    if (event.persist) {
      event.persist()
    }

    this.setState(
      {
        keyword: event.target.value,
      },
      () => {
        this.search()
      },
    )
  }

  handleRemoveSelectedMall = e => {
    e.preventDefault()
    e.stopPropagation()

    const {
      // setSelectedMallSlug,
      isEfoodChoices,
    } = this.props

    this.handleSelectMall(null)

    this.setState(
      {
        mallId: '',
      },
      () => {
        isEfoodChoices && this.search()
      },
    )
  }

  handleSelectMall = async id => {
    const { onCloseSelectMall } = this.props

    if (id === null) {
      if (onCloseSelectMall) {
        onCloseSelectMall()
      }

      this.setState(
        {
          showSearchMall: false,
          selectedMall: { name: '' },
        },
        () => {
          this.search({})
        },
      )
      return
    }

    const { malls } = this.props
    let selectedMall = null

    malls.forEach(mall => {
      if (mall.id === id) {
        selectedMall = mall
      }
    })
    // setSelectedMallSlug(selectedMall.slugName)

    if (onCloseSelectMall) {
      onCloseSelectMall()
    }

    this.setState(
      {
        showSearchMall: false,
        selectedMall,
        mallId: id,
      },
      () => {
        this.search({})
      },
    )
  }

  handleSearchMallClose = () => {
    this.setState({
      showSearchMall: false,
    })
  }

  onFavoriteClicked = async id => {
    const { accessToken, favoriteMalls } = this.props

    if (accessToken !== null) {
      try {
        if (
          favoriteMalls.length === 3 &&
          !favoriteMalls.map(m => m.id).includes(id)
        ) {
          this.setState({
            maxFavoriteModalVisible: true,
          })
          return favoriteMalls
        }

        const favoriteResponse = await ProfileApiServices.postFavoriteMall(
          id,
          accessToken,
        )

        this.setState({
          favoriteMalls: favoriteResponse.data,
        })

        return favoriteResponse.data
      } catch (error) {
        const { data = {} } = error.response || {}
        const { message = 'Network Error' } = data || {}
        throw new Error(message)
      }
    }

    this.setState({
      loginPromptModalVisible: true,
    })

    return []
  }

  onLoginConfirmOk = () => {
    const { push } = this.props

    this.setState({
      loginPromptModalVisible: false,
    })

    push('/login')
  }

  onRegisterConfirmOk = () => {
    const { push } = this.props

    this.setState({
      loginPromptModalVisible: false,
    })

    push('/register')
  }

  toggleDialogModal = visible => {
    this.setState({
      maxFavoriteModalVisible: visible,
    })
  }

  render() {
    const {
      malls,
      isOpenSelectMall,
      deviceLocation,
      favoriteMalls,
      setFavoriteMalls,
      accessToken,
      altTitle,
      isEconcierge,
      isEfoodChoices,
      isExplore,
    } = this.props
    const {
      results_articles,
      results_places,
      recentSearches,
      popularPlaces,
      isUserSearching,
      keyword,
      mallId,
      loading,
      showSearchMall,
      selectedMall,
      positionLoading,
      position,
      loginPromptModalVisible,
      maxFavoriteModalVisible,
    } = this.state

    return (
      <>
        <StyledReactModal
          isOpen
          style={{ overlay, content }}
          onRequestClose={this.modalClose}
          closeTimeoutMS={150}
          bodyOpenClassName="sticky-modal-open"
          htmlOpenClassName="sticky-modal-open"
        >
          <SearchContentContainer>
            <Header>
              <Title>{altTitle ? altTitle : 'Search'}</Title>
              <CloseIcon onClick={this.modalClose}>
                <Icon name="x" />
              </CloseIcon>
            </Header>
            <SearchFieldsContainer>
              <TextInput
                name="keyword"
                variant="withIcon"
                iconName="search"
                onChange={this.handleKeywordChange}
                placeholder="What are you looking for?"
              />
              <OffsetInput>
                <TextInput
                  variant="withIcon"
                  iconName={selectedMall.name ? 'x' : 'caret'}
                  onClick={this.showSelectMall}
                  placeholder="Select Mall"
                  onIconClick={this.handleRemoveSelectedMall}
                  readOnly
                  initialValue={selectedMall.name}
                  value={selectedMall.name}
                />
              </OffsetInput>
              <InputHidden value={selectedMall.id} />
            </SearchFieldsContainer>
            {!positionLoading && position === null && (
              <PositionErrorWrapper>
                <PositionError>
                  <PositionErrorIcon>
                    <Icon name="location" />
                  </PositionErrorIcon>
                  <PositionErrorText>
                    Location is currently off. Turn on location on your browser
                    settings.
                  </PositionErrorText>
                </PositionError>
              </PositionErrorWrapper>
            )}
            <SearchResults key={keyword}>
              {!loading ? (
                results_articles.length > 0 ||
                results_places.length > 0 ||
                (popularPlaces.length &&
                  !keyword &&
                  (isEconcierge || !mallId)) ? (
                  <>
                    {!(
                      results_articles.length > 0 || results_places.length > 0
                    ) &&
                      recentSearches.length > 0 && (
                        <>
                          <Label>
                            <LabelText>Recent Searches</LabelText>
                            <ClearSearch onClick={this.clearRecentSearches}>
                              Clear all
                            </ClearSearch>
                          </Label>
                          <RecentSearchWrapper>
                            {recentSearches.map((result, index) => (
                              <RecentSearchItem
                                key={`${result.itemId}-type-${result.type}`}
                                onClick={() => this.resultClick(result)}
                              >
                                {result.title}
                              </RecentSearchItem>
                            ))}
                          </RecentSearchWrapper>
                        </>
                      )}
                    <Label>
                      <LabelText>
                        {keyword ||
                        (mallId && !isEconcierge) ||
                        (!keyword && isEfoodChoices)
                          ? 'Search Result'
                          : !isEfoodChoices && 'Popular places'}
                      </LabelText>
                    </Label>
                    {results_articles.length !== 0 && (
                      <ResultEvents>
                        <StyledSlider
                          initialSlide={0}
                          infinite={false}
                          variableWidth
                          // focusOnSelect
                          draggable
                          easing="ease"
                          beforeChange={this.handleBeforeChange}
                          afterChange={this.handleAfterChange}
                        >
                          {results_articles.map((result, index) => (
                            <ResultEventContainer>
                              <ResultEvent
                                key={`${result.itemId}-type-${result.type}`}
                                onClick={() =>
                                  this.resultClick(result, 'events')
                                }
                              >
                                <EventImage src={result.iconUrl} />
                                <ResultEventText>
                                  <SearchEventTitle>
                                    {result.title}
                                  </SearchEventTitle>
                                  <EventSubtitle>
                                    {result.subtitle}
                                  </EventSubtitle>
                                </ResultEventText>
                              </ResultEvent>
                            </ResultEventContainer>
                          ))}
                        </StyledSlider>
                      </ResultEvents>
                    )}
                    {(keyword || (mallId && !isEconcierge) || isEfoodChoices
                      ? results_places
                      : popularPlaces
                    ).map((result, index) => (
                      <Result
                        key={`${result.itemId}-type-${result.type}`}
                        onClick={() => this.resultClick(result)}
                      >
                        <ResultText>
                          <SearchTitle>{result.title}</SearchTitle>
                          <Subtitle>{result.subtitle}</Subtitle>
                        </ResultText>
                      </Result>
                    ))}
                  </>
                ) : (
                  isUserSearching &&
                  keyword && (
                    <>
                      <NoResults>
                        <Icon name="warning" />{' '}
                        {isExplore
                          ? 'No merchants found. Try a different search.'
                          : 'No Results Found.'}
                      </NoResults>
                    </>
                  )
                )
              ) : (
                <LoaderContainer>
                  <StyledLoader />
                </LoaderContainer>
              )}
            </SearchResults>
          </SearchContentContainer>
          <StyledSearchMall
            show={showSearchMall || isOpenSelectMall}
            malls={malls}
            onFavoriteClicked={this.onFavoriteClicked}
            onSelectMall={this.handleSelectMall}
            onPageClose={this.handleSearchMallClose}
            deviceLocation={deviceLocation}
            favoriteMalls={favoriteMalls}
            setFavoriteMalls={setFavoriteMalls}
            accessToken={accessToken}
            efood={isEfoodChoices}
            displayClose={!isOpenSelectMall}
          />
        </StyledReactModal>
        <DialogModal
          modalState={loginPromptModalVisible}
          title="Zing account required"
          description="Register or login to use this feature."
          align="center"
          onCancel={this.onRegisterConfirmOk}
          cancelText="Register Now"
          onOk={this.onLoginConfirmOk}
          onClose={() => {
            this.setState({
              loginPromptModalVisible: false,
            })
          }}
          okText="Log In"
          showCloseButton
        />
        <DialogModal
          modalState={!!maxFavoriteModalVisible}
          title="Favorite Malls"
          description="You can only select up to 3 favorite malls"
          okText="Okay"
          onOk={() => this.toggleDialogModal(false)}
          hasCancel={false}
          align="center"
        />
      </>
    )
  }
}
SearchModal.defaultProps = {
  malls: [],
}

SearchModal.propTypes = {
  malls: PropTypes.array,
}

export default SearchModal
